import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../../actions/fillCombo_action';
import { cityActionId, countryActionId, toastError, toastSuccess } from "../../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { addExhibitionMaster_action, getExhibitionMasterDetails_action, updateExhibitionMaster_action } from "../../../../../actions/admin_module_action/master_action/exhibition_master_action";


class MasterExhibitionAU extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            countryId: '',
            countryList: [],
            TempCountryList: [],
            Country: '',
            Name: '',
            Code: '',
            BankDetails: '',
            fromDate: '',
            toDate: '',
            is_add: false,
            ExihibitionID: '',
            is_update: false,
            isDisplayCountryList: false,
        }
        this.getFillList = this.getFillList.bind(this)
        this.onCountrySearch = this.onCountrySearch.bind(this)
        this.renderCountryList = this.renderCountryList.bind(this)
        this.addExhibitionMaster = this.addExhibitionMaster.bind(this)
        this.getExhibitionMasterDetails = this.getExhibitionMasterDetails.bind(this)
        this.handleBack = this.handleBack.bind(this)
        this.updateExhibitionMaster = this.updateExhibitionMaster.bind(this)
        this.exhibitionMasterAU = this.exhibitionMasterAU.bind(this)

    }

    componentDidMount() {
        this.setState({
            is_add: this.props.location.state != null && this.props.location.state.is_add != null ? this.props.location.state.is_add : false,
            is_update: this.props.location.state != null && this.props.location.state.is_update != null ? this.props.location.state.is_update : false,
            ExihibitionID: this.props.location.state != null && this.props.location.state.ExihibitionID != null ? this.props.location.state.ExihibitionID : '',
        })
        this.getFillList(countryActionId, '', '', '', '')
        setTimeout(() => {
            this.state.is_update && this.getExhibitionMasterDetails()
        }, 200);
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props.fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // Country List
                    if (actionID === countryActionId) {
                        console.log("country data", data.data)
                        this.setState({
                            countryList: data.data,
                            TempCountryList: data.data,
                            isLoading: false
                        })
                    }
                }
            }
            )
    }

    getExhibitionMasterDetails() {
        const { ExihibitionID } = this.state
        this.setState({ isLoading: true })
        this.props.getExhibitionMasterDetails_action(ExihibitionID)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    this.setState({
                        Name: data.data[0].ExhibitionName,
                        Code: data.data[0].Code,
                        countryId: data.data[0].CountryID,
                        BankDetails: data.data[0].BankDetails,
                        fromDate: moment(data.data[0].ExhibitionDateFrom, 'YYYY-MM-DD').toDate(),
                        toDate: moment(data.data[0].ExhibitionDateTo, 'YYYY-MM-DD').toDate(),

                    })
                    this.state.countryList.map(id => parseInt(id.CountryCode) == data.data[0].CountryID && this.setState({ Country: id.Description }))
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onCountrySearch(e) {
        console.log(e.target.value)
        const { countryList, TempCountryList } = this.state
        if (e.target.value != '') {
            var searchCountryList = TempCountryList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                Country: e.target.value,
                // billCountryErr: '',
                TempCountryList: searchCountryList,
                isDisplayCountryList: true
            })
        } else {
            this.setState({
                Country: e.target.value,
                TempCountryList: countryList,
                isDisplayCountryList: false
            })
        }
    }

    addExhibitionMaster() {
        const { Name, Code, countryId, fromDate, toDate, BankDetails } = this.state
        if (Name != '' && Name != null && Code != '', Code != null, countryId != '' && countryId != null && fromDate != '', fromDate != null, toDate != '', toDate != null, BankDetails != '' && BankDetails != null) {

            this.setState({ isLoading: true })
            this.props.addExhibitionMaster_action(Name, Code, countryId, fromDate, toDate, BankDetails)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ isLoading: false })
                        toastSuccess("data added successfully")
                        this.props.navigate('/exhibitionMasterList', { state: { is_add: true, } })
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
        else {
            toastError("Pleaser Enter Mandatory Fields")
        }
    }

    exhibitionMasterAU() {
        if (this.state.is_add == true) {
            this.addExhibitionMaster()
        }
        else {
            this.updateExhibitionMaster()
        }
    }

    handleBack() {
        this.props.navigate('/exhibitionMaster')
    }

    renderCountryList() {
        const { TempCountryList } = this.state
        return (
            <ul className="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    TempCountryList.length > 0 && TempCountryList.map(data => (
                        <li className="list-group-item" key={Math.random()}
                            onClick={e => this.setState({
                                Country: data.Description, countryId: data.Code, isDisplayCountryList: false
                            })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }

    updateExhibitionMaster() {
        const { Name, Code, countryId, fromDate, toDate, BankDetails, ExihibitionID } = this.state
        if (Name != '' && Name != null && Code != '', Code != null, countryId != '' && countryId != null && fromDate != '', fromDate != null, toDate != '', toDate != null, BankDetails != '' && BankDetails != null && ExihibitionID != '' && ExihibitionID != null) {

            this.setState({ isLoading: true })
            this.props.updateExhibitionMaster_action(ExihibitionID, Name, Code, countryId, fromDate, toDate, BankDetails)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ isLoading: false })
                        toastSuccess("data updated successfully")
                        this.props.navigate('/exhibitionMasterList', { state: { is_add: true, } })
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
        else {
            toastError("Pleaser Enter Mandatory Fields")
        }
    }

    render() {
        const { isLoading, countryId, Name, Code, BankDetails, toDate, fromDate, Country, TempCountryList, isDisplayCountryList, countryList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <div className={JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ? "with-dr-container" : "with-dr-container com-height"}>
                    <div className="main-container">
                        <AdminDrawer />
                        <div className="row">
                            <div className="step-name-space" style={{ zIndex: 9 }}>
                                <p>Exhibition Master {this.state.is_add == true ? 'Add' : 'Update'}</p>
                            </div>
                        </div>
                        <div class="card-body mt-5">
                            <div class="row ">
                                <div class="row ">
                                    <div class="col-md-4">
                                        <label for="validationCustom03">Exhibition Name<span style={{ color: 'red' }}>*</span></label>
                                        <input value={Name} onChange={(e) => this.setState({ Name: e.target.value })} type="text" class="form-control" placeholder="Name" />
                                    </div>
                                    <div class="col-md-4">
                                        <label for="validationCustom03">Code<span style={{ color: 'red' }}>*</span></label>
                                        <input value={Code} onChange={(e) => this.setState({ Code: e.target.value })} type="text" class="form-control" placeholder="Code" />
                                    </div>
                                    <div className="col-xl-4">
                                        <label htmlFor="validationCustom03">
                                            Country<span className="text-red">*</span>
                                        </label>
                                        <input
                                            placeholder="Country"
                                            type="text"
                                            className="form-control"
                                            id="validationCustom03"
                                            // disabled={is_view || isSameAsCorrespondence}
                                            value={Country}
                                            onChange={(e) => this.onCountrySearch(e)}
                                        />
                                        {isDisplayCountryList && this.renderCountryList()}
                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{billCountryErr}</span>} */}

                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-4">
                                        <label for="validationCustom03">Bank Details<span style={{ color: 'red' }}>*</span></label>
                                        <input value={BankDetails} onChange={(e) => this.setState({ BankDetails: e.target.value })} type="text" class="form-control" placeholder="Bank Details" />
                                    </div>
                                    <div class="col-md-4">
                                        <div className="col-xl-12 p-0">
                                            <label htmlFor="validationCustom03">From Date<span style={{ color: 'red' }}>*</span></label>
                                            <DatePicker
                                                style={{ zIndex: '99999' }}
                                                selected={fromDate}
                                                dateFormat={"dd/MM/yyyy"}
                                                className="form-control"
                                                onChange={(date) => this.setState({ fromDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())) })}
                                                peekNextMonth
                                                maxDate={toDate}
                                                minDate={new Date()}
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                placeholderText="From Date"
                                            />
                                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{circularDateErr}</span>} */}
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div className="col-xl-12 p-0">
                                            <label htmlFor="validationCustom03">To Date<span style={{ color: 'red' }}>*</span></label>
                                            <DatePicker
                                                style={{ zIndex: '99999' }}
                                                selected={toDate}
                                                dateFormat={"dd/MM/yyyy"}
                                                className="form-control"
                                                onChange={(date) => this.setState({ toDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())) })}
                                                peekNextMonth
                                                minDate={fromDate}
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                placeholderText="To Date"
                                            />
                                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{circularDateErr}</span>} */}
                                        </div> </div>
                                </div>
                                <button onClick={this.exhibitionMasterAU} class="btn rounded-0 btn-primary mt-3" style={{ padding: "5px 7px", marginLeft: "10px", width: "100px" }}>Save</button>
                                <button onClick={this.handleBack} class="btn rounded-0 btn-danger mt-3" style={{ padding: "5px 7px", marginLeft: "10px", width: "100px" }}>Back</button>
                            </div>
                        </div>
                    </div>

                </div>
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, addExhibitionMaster_action, getExhibitionMasterDetails_action, updateExhibitionMaster_action })(MasterExhibitionAU));